import React, { useState } from 'react';
import { useRollbar } from '@rollbar/react';
import { Select, Spin } from 'antd';
import { GeoApiV2 } from 'api/geo-location-v2';

function SearchVillage({ ...props }) {
  const [isLoading, setIsLoading] = useState(false);
  const [villages, setVillages] = useState([]);
  const rollbar = useRollbar();

  const onSearchVillage = async (search) => {
    if (search.length > 2) {
      try {
        setIsLoading(true);
        const res = await GeoApiV2.searchVillage(search);
        setVillages(res?.data?.data || []);
        setIsLoading(false);
      } catch (error) {
        setIsLoading(false);
        rollbar.error(`Error when search village on edit acquisition detail page`, error);
      }
    }
  };

  return (
    <Select
      labelInValue
      placeholder="Type to search location"
      showSearch
      filterOption={false}
      onSearch={onSearchVillage}
      notFoundContent={isLoading ? <Spin size="small" /> : 'Data not Found, type another keyword'}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
    >
      {villages.map((item) => (
        <Select.Option key={item.id} value={item.id}>
          {item.name}
        </Select.Option>
      ))}
    </Select>
  );
}

export default SearchVillage;
